import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { rendersMenuItemForType } from '../../../../../../app/shared/menu/menu-item.decorator';
import { ExternalLinkMenuItemComponent as BaseComponent } from '../../../../../../app/shared/menu/menu-item/external-link-menu-item.component';
import { MenuItemType } from '../../../../../../app/shared/menu/menu-item-type.model';

/**
 * Component that renders a menu section of type EXTERNAL.
 * BfS: external links are opened in a new tab.
 */
@Component({
  selector: 'ds-themed-external-link-menu-item',
  styleUrls: ['../../../../../../app/shared/menu/menu-item/menu-item.component.scss'],
  templateUrl: './external-link-menu-item.component.html',
  standalone: true,
  imports: [NgClass, TranslateModule, RouterLinkActive],
})
@rendersMenuItemForType(MenuItemType.EXTERNAL)
export class ExternalLinkMenuItemComponent extends BaseComponent {
}
